
// TRAINING TYPES
export const GET_TRAINING_TYPES = "/training-types";
export const ADD_NEW_TRAINING_TYPE = "/training-types";
export const UPDATE_TRAINING_TYPE = "/training-types";
export const DELETE_TRAINING_TYPE = "/training-types";


